import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useBlogStore } from "../../store/blog-store";
import { useBlogInitializer } from "../../hooks/useBlogInitializer"

const BlogDetail = () => {
useBlogInitializer(); //  ADD THIS LINE
  const { id } = useParams();
  const navigate = useNavigate();
  const blogs = useBlogStore((s) => s.blogs);

  const blog = blogs.find((b) => b.id === id);

  if (!blog)
    return <div className="text-center mt-20">Blog not found</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">

      {/* Back button */}
      <button
        onClick={() => navigate("/blog")}
        className="mb-6 text-primary hover:text-primary-dark transition-colors font-medium inline-block"
      >
        ← Back to Blogs
      </button>

      {/* Main image */}
      <img
        src={blog.image}
        alt=""
        className="w-full h-[420px] object-cover rounded-xl mb-8"
      />

      {/* Title */}
      <div
        className="text-4xl font-bold mb-6"
        dangerouslySetInnerHTML={{ __html: blog.title }}
      />

      {/* Paragraph */}
      <div
        className="text-lg text-gray-700 mb-10 leading-8"
        dangerouslySetInnerHTML={{ __html: blog.paragraph }}
      />

      {/* Dynamic Sections */}
      {blog.dynamicBlog?.map((item, i) => (
        <div key={i} className="mb-14">

          {/* <div
            dangerouslySetInnerHTML={{ __html: item.title }}
          />

          <img
            src={item.image}
            alt=""
            className="w-full h-96 object-cover rounded-lg my-5"
          /> */}

          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: item.content }}
          />

        </div>
      ))}
    </div>
  );
};

export default BlogDetail;
